export default __webpack_public_path__ + "static/media/12_Barefoot_Share.b4d42ce3.jpg";